module.exports = __webpack_public_path__ + "static/media/home2-slider-5.45451c14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home2-slider-5.jpg
// module id = 1152
// module chunks = 33